// router/index.ts
import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';
import Login from '@/views/Login.vue';
import Overview from '@/views/Overview.vue';
import { useConfigStore } from '@/stores/configsStore';

// Define public routes that don't require authentication
const publicRoutes = ['/login', '/']

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Login,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/home', // Changed from /overview to /home
    name: 'Home',  // Changed from Overview to Home
    component: Overview,
    meta: { requiresAuth: true }
  },
  {
    path: '/data/:id',
    name: 'Data',
    component: () => import('@/views/LinkView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('@/views/Logout.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'User Management',
    component: () => import('@/views/UserList.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/user/:id',
    name: 'User',
    component: () => import('@/views/UserManagement.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('@/views/Error.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const isAuthenticated = authStore.isAuthenticated;
  const requiresAuth = to.meta.requiresAuth;
  const requiresAdmin = to.meta.requiresAdmin;
  const isPublicRoute = publicRoutes.includes(to.path);
  const isAdmin = authStore.isAdmin;

  // Set the document title from route metadata (fallback to default)
  const appTitle = useConfigStore().appTitle
  document.title = `${(to.name as string)} | ${appTitle}` || appTitle;

  if (requiresAuth && !isAuthenticated) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else if (requiresAdmin && !isAdmin) {
    next({
      path: '/error',
      query: { redirect: to.fullPath }
    });
  } else if (isPublicRoute && isAuthenticated) {
    next({ path: '/home' }); // Changed from /overview to /home
  } else {
    next();
  }
});

export default router;